
import React, { useState, } from "react";
import translate from "../i18n/Translator";
import { Tabs, Tab, Grid, } from "@material-ui/core";
import queryString from 'query-string';
import TabPanel, { a11yProps } from "../components/TabsGenerator";
import Surface from "../components/Surface";
import { PaymentIcon } from "../components/Icons";
import ExpedientTemplatesView from "../expedient_template/ExpedientTemplates";
import ShippingTemplates from "../shipping_templates/ShippingTemplates";
import { RouterParams } from "../router/RouterParams";
import { useHistory } from "react-router-dom";
import ProviderFieldsList from "../provider_fields/ProviderFieldsList";

interface TemplateTab {
    name: string;
    title: string;
    actions?: string[];
}

export default function FieldTemplates({ match }: RouterParams) {
    const history = useHistory();

    const qs = queryString.parse(window.location.search);

    const allTabs = [
        {
            name: "expedient_templates",
            title: translate("field_templates.tab_expedient_templates" as string)
        },
        {
            name: "shipping_templates",
            title: translate("field_templates.tab_shipping_templates" as string)
        },
        {
            name: "provider_fields",
            title: translate("field_templates.tab_provider_fields" as string)
        },
    ] as TemplateTab[];

    const [tabs] = useState<TemplateTab[]>(allTabs);

    const tabContent = (index: number) => {
        let current = tabs[index];
        if (!current) return;

        switch (current.name) {
            case "expedient_templates":
                return (<ExpedientTemplatesView></ExpedientTemplatesView>);
            case "shipping_templates":
                return (<ShippingTemplates match={match} />);
            case "provider_fields":
                return (<ProviderFieldsList match={match} />);
            default:
                return (<></>);
        }
    };


    const tabToIndex = (tab: string): number => {
        let index = tabs.findIndex((t) => t.name === tab);
        return Math.max(index, 0);
    };

    const tabQs = (): number => {
        if (typeof qs.tab === "string") {
            return tabToIndex(qs.tab)
        }
        return 0;
    };
    const [value, setValue] = useState<number>(tabQs);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        let newTab = tabs[newValue];
        if (newTab && newValue != value) {
            const newParams = new URLSearchParams();
            newParams.set("tab", newTab.name);
            history.replace({
                search: newParams.toString(),
            });
        }
        setValue(newValue);

    };

    return (
        <Surface title={translate("field_templates.title" as string)} subtitle={translate("field_templates.subtitlte" as string)} icon={<PaymentIcon />}
            className="PaperPagination PaperTabContainer">

            <Tabs value={value} onChange={handleChange} aria-label={translate("field_templates.title") as string}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto">
                {tabs.map((tab: TemplateTab, index: number) => (
                    <Tab key={tab.name} label={tab.title} {...a11yProps(index)} />
                ))}
            </Tabs>

            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    {tabs.map((tab: TemplateTab, index: number) => (
                        <TabPanel key={tab.name} value={value} index={index}>
                            {tabContent(index)}
                        </TabPanel>
                    ))}
                </Grid>
            </Grid>

        </Surface>

    );
}
